import {gql, useQuery} from '@apollo/client';
import type {QueryHookOptions} from '@apollo/client';

import type {FsmStatesQuery} from '../types/graphql';

/**
 * Query to fetch conversations for following-up on.
 */
export const FSM_STATES = gql`
  query FsmStates {
    fsm {
      meta {
        states
      }
    }
  }
`;

/**
 * Hook to run the FSM States query.
 */
export const useFsmStates = (opts?: QueryHookOptions<FsmStatesQuery>) =>
  useQuery<FsmStatesQuery>(FSM_STATES, opts);
